import useAuth from "../hooks/useAuth";
import { resolveHelpBrand } from "./branding";
import { searchArticles } from "./catalogue";
export default function useHelp() {
  const { user } = useAuth();
  return {
    user,
    brand: resolveHelpBrand(user),
    articles: searchArticles(user),
  };
}
